// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"629dfccd","626":"21a58533"}[chunkId] + ".chunk.js";
};